import React from 'react';
import './index.scss';
import _ from 'lodash';

const PublishedDate = ({
  publishedAt = '',
  updatedAt = '',
  children,
  publishedAtTitle = 'Published',
  updatedAtTitle = 'Updated'
}) => {
  const getFormattedDate = date => {
    return _.getFormattedDate(date, 'Mon D YYYY');
  };
  return (
    <div className="authorData bottomList publishDateRow">
      <div className="lastUpdated">
        {updatedAt && (
          <>
            {updatedAtTitle} {getFormattedDate(updatedAt)}
          </>
        )}
        {updatedAt && publishedAt && <>&nbsp; • &nbsp;</>}
        {publishedAt && (
          <>
            {publishedAtTitle} {getFormattedDate(publishedAt)}
          </>
        )}
      </div>
      {children}
    </div>
  );
};

export default PublishedDate;
